import React from 'react';
import { AiRovoButtonNodeProviderWithBoundary } from '@jira/ai-rovo_button/src/ui/AiRovoButtonNodeProviderWithBoundary.tsx';
import { AiRovoCurrentRouteConfigurationProviderWithBoundary } from './AiRovoCurrentRouteConfigurationProviderWithBoundary.tsx';

export const AiRovoRouteProvider = (): React.JSX.Element => {
	return (
		<>
			<AiRovoButtonNodeProviderWithBoundary />
			<AiRovoCurrentRouteConfigurationProviderWithBoundary />
		</>
	);
};
